import { DownOutlined } from '@ant-design/icons';
import { css, cx } from '@emotion/css';
import { Collapse } from 'antd';
import { useTranslate } from '@tolgee/react';
import { ProductInfo } from './ProductInfo';
import { useQuery } from '@tanstack/react-query';
import { queries } from 'services/queries';
import { useEffect, useState } from 'react';

interface InquiredProductPanelProps {
  buyerId: Conversation.Conversation['buyerId'];
  storeId: Conversation.Conversation['storeId'];
}

export const InquiredProductPanel = (props: InquiredProductPanelProps) => {
  const { buyerId, storeId } = props;
  const { t } = useTranslate();
  const [activeKey, setActiveKey] = useState<string | undefined>(undefined);

  const { data: inquiredProduct } = useQuery({
    ...queries.conversations.inquiredProduct({
      internal_store_id: storeId,
      internal_buyer_id: buyerId,
    }),
  });

  const hasProduct = !!inquiredProduct;

  useEffect(() => {
    setActiveKey(hasProduct ? 'InquiredProduct' : undefined);
  }, [hasProduct]);

  return (
    <Collapse
      activeKey={activeKey}
      className={cx(styles, 'flex-shrink-0')}
      bordered={false}
      expandIconPosition="right"
      expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
      onChange={(key) => setActiveKey(key as string)}
    >
      <Collapse.Panel header={t('sidebar.productInquiries.title')} key="InquiredProduct">
        {hasProduct ? (
          <ProductInfo storeId={storeId} product={inquiredProduct} />
        ) : (
          <div className="text-center text-[var(--fett-text-quaternary)]">
            {t('sidebar.productInquiries.emptyDescription')}
          </div>
        )}
      </Collapse.Panel>
    </Collapse>
  );
};

const styles = css`
  background-color: var(--fett-bg-elevated);

  .ant-collapse-item {
    border: none;
  }

  .ant-collapse-item > .ant-collapse-header {
    padding-top: 11px;
    padding-bottom: 11px;
    padding-left: 12px;
    font-weight: 500;
    color: var(--fett-text-primary);

    .anticon {
      right: 12px;
    }
  }

  .ant-collapse-content-box {
    padding-left: 0;
    padding-right: 0;
  }
`;
